import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSQuickListServices {

    static getAllQuickLists(pharmacyId, params = {}) {
        return axios.get(`${URL.PMS_GET_ALL_QUICK_LISTS}/${pharmacyId}`, {
            ...PMSQuickListServices.getAuthHeader(),
            params,
        });
    }

    static getQuickListById(id, pharmacyId) {
        return axios.get(`${URL.PMS_GET_QUICK_LIST_BY_ID}/${id}/${pharmacyId}`, PMSQuickListServices.getAuthHeader());
    }

    static createQuickListItem(pharmacyId, type, data) {
        return axios.post(`${URL.PMS_CREATE_QUICK_LIST}/${pharmacyId}`, {type, ...data}, PMSQuickListServices.getAuthHeader());
    }

    static updateQuickListItem(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_QUICK_LIST}/${id}/${pharmacyId}`, data, PMSQuickListServices.getAuthHeader());
    }

    static deleteQuickListItem(id, pharmacyId) {
        return axios.delete(`${URL.PMS_DELETE_QUICK_LIST}/${id}/${pharmacyId}`, PMSQuickListServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
